import React from 'react'
import * as Styled from './styled';
import * as Comp from '../../../Components/Form';
import PakgeList from './pakgesList';
import CoursesList from './CoursesList';
import { useNavigate, useParams } from 'react-router-dom';

const ShowCourse = () => {
    const { ClassName } = useParams()
    const [filter, setFiltter] = React.useState('0');
    const handleChange = (event) => {
        setFiltter(event.target.value);
    };
    const [filterNav, setFiltterNav] = React.useState(ClassName);
    const handleChangeNav = (event) => {
        setFiltterNav(event.target.value);
    };
    const navigate = useNavigate()
    React.useEffect(() => {
        navigate(`/all-course/${filterNav}`)
    }, [filterNav])

    return (
        <Styled.Section>
            <Styled.Filter >
                <Styled.FilterDrop>
                    <Comp.DropDown onChange={handleChangeNav} with='100%' value={filterNav} >
                        <Styled.FilterMenu value="تاسع" >تاسع</Styled.FilterMenu>
                        {/* <Styled.FilterMenu value="بكلوريا أدبي" > بكالوريا أدبي  </Styled.FilterMenu> */}
                        <Styled.FilterMenu value="بكلوريا علمي" > بكالوريا علمي  </Styled.FilterMenu >
                    </Comp.DropDown>
                </Styled.FilterDrop>
                <Styled.FilterDrop>
                    <Comp.DropDown onChange={handleChange} with='100%' value={filter}  >
                        <Styled.FilterMenu value="0" >الكل</Styled.FilterMenu>
                        <Styled.FilterMenu value="1" >  حزمة مواد</Styled.FilterMenu>
                        <Styled.FilterMenu value="2" > مواد فرديّة</Styled.FilterMenu >
                    </Comp.DropDown>
                </Styled.FilterDrop>
            </Styled.Filter>
            <PakgeList filter={filter} />
            <CoursesList filter={filter} />
        </Styled.Section>
    )
}

export default ShowCourse